
import { useGetPaymentApprovalSummaryQuery } from "../../lib/apiSlice/property/propertySlice.tsx";
import BulkPaymentsTable from "./_bulkpayments_table.jsx";
import { Helmet } from "react-helmet";

export default function BulkPaymentsApproval() {
    const { data, isLoading, error } = useGetPaymentApprovalSummaryQuery();

    return (
        <div className="space-y-6">
            <Helmet>
                <title>Payment Approvals</title>
                <meta name="description" content="Payments Approvals" />
            </Helmet>


            <BulkPaymentsTable
                approvalData={data?.approval_details}
                isloading={isLoading}
            />
        </div>
    );
}

